import { useRequest } from 'features/request/useRequest';
import { graphql } from 'gql';
import type { AuditLogClientOperationEnum } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const logUserClientGql = graphql(`
    mutation logUserClient($loginOp: AuditLogClientOperationEnum!, $userName: String!) {
        logUserClient(loginOp: $loginOp, userName: $userName) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const useSendLoginOperation = () => {
    const dispatch = useDispatch();

    const [, , , sendLoginOperationRequest] = useRequest({
        requestId: 'logUserClient',
        query: logUserClientGql,
        withEffect: false,
    });

    const sendLoginOperationHandler = useCallback(
        ({ operation, userName }: { operation: AuditLogClientOperationEnum; userName?: string }) => {
            if (userName && operation) {
                const variables = { loginOp: operation, userName };

                dispatch(sendLoginOperationRequest(variables));
            }
        },
        [dispatch, sendLoginOperationRequest],
    );

    return {
        sendLoginOperationHandler,
    };
};
